"use strict";
exports.__esModule = true;
exports.DEV_MENU = void 0;
exports.DEV_MENU = {
    DEV_AUTH: 'Dev Auth'
};
